/**
 * Bundle Upsell Cart Functionality
 */
document.addEventListener('DOMContentLoaded', function() {
  initBundleUpsell();

  if (window.MinimogEvents) {
    window.MinimogEvents.subscribe('ON_CART_UPDATE', function() {
      initBundleUpsell();
    });
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('.sf-cart-icon') || e.target.closest('[data-cart-drawer-toggle]') || e.target.closest('.js-cart-drawer-toggle') || e.target.closest('[data-open-cart-drawer]')) {
      setTimeout(initBundleUpsell, 300);
    }
  });

  function initBundleUpsell() {
    var bundleButtons = document.querySelectorAll('[data-add-bundle]');

    bundleButtons.forEach(function(button) {
      button.replaceWith(button.cloneNode(true));
    });

    var newBundleButtons = document.querySelectorAll('[data-add-bundle]');

    newBundleButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();

        var hasVariants = parseInt(this.dataset.hasVariants) > 1;
        var bundleItem = this.closest('.bundle-upsell__item');
        var modal = bundleItem ? bundleItem.querySelector('[data-bundle-variant-modal]') : null;

        if (hasVariants && modal) {
          modal._addBtn = this;
          openVariantModal(modal, this);
        } else {
          addBundleToCart(this);
        }
      });
    });

    // Modal close buttons
    document.querySelectorAll('[data-bundle-modal-close]').forEach(function(el) {
      el.addEventListener('click', function() {
        var modal = this.closest('[data-bundle-variant-modal]');
        if (modal) closeVariantModal(modal);
      });
    });

    // Modal variant option buttons
    document.querySelectorAll('[data-bundle-modal-variant]').forEach(function(option) {
      option.addEventListener('click', function() {
        var variantId = this.dataset.bundleModalVariant;
        var modal = this.closest('[data-bundle-variant-modal]');
        // Store reference to the add button before modal was moved to body
        var addBtn = modal ? modal._addBtn : null;

        if (addBtn) {
          addBtn.dataset.variantId = variantId;
          if (modal) closeVariantModal(modal);
          addBundleToCart(addBtn);
        }
      });
    });
  }

  function openVariantModal(modal, btn) {
    // Move modal to body so position:fixed works correctly (cart drawer has transform)
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    modal.style.display = 'block';
    requestAnimationFrame(function() {
      modal.classList.add('is-open');
    });
  }

  function closeVariantModal(modal) {
    modal.classList.remove('is-open');
    setTimeout(function() {
      modal.style.display = 'none';
    }, 200);
  }

  function addBundleToCart(btn) {
    var variantId = btn.dataset.variantId;
    var originalItemId = btn.dataset.originalId;
    var bundleItem = btn.closest('.bundle-upsell__item');
    var btnText = btn.querySelector('.btn-text');
    var btnLoading = btn.querySelector('.btn-loading');

    btn.classList.add('loading');
    btn.disabled = true;
    if (btnText) btnText.style.display = 'none';
    if (btnLoading) btnLoading.style.display = 'block';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(function(response) {
      if (!response.ok) throw new Error('Failed to add to cart');
      return response.json();
    })
    .then(function(data) {
      if (originalItemId) {
        return fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var originalItem = cart.items.find(function(item) {
              return item.product_id == originalItemId;
            });
            if (originalItem) {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  id: originalItem.key,
                  quantity: originalItem.quantity - 1
                })
              });
            }
          })
          .then(function() { return data; });
      }
      return data;
    })
    .then(function(data) {
      if (bundleItem) {
        bundleItem.style.transition = 'opacity 0.3s ease';
        bundleItem.style.opacity = '0';

        setTimeout(function() {
          bundleItem.remove();
          var container = document.querySelector('.cart-bundle-upsell');
          var remainingItems = container ? container.querySelectorAll('.bundle-upsell__item') : [];
          if (container && remainingItems.length === 0) {
            container.style.display = 'none';
          }
        }, 300);
      }

      var titleEl = bundleItem ? bundleItem.querySelector('.cart-bundle-product-title') : null;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Bundle cart upgrade': titleEl ? titleEl.textContent.trim() : 'Bundle'
          }
        })
      });

      if (window.Shopify && window.Shopify.onItemAdded) {
        window.Shopify.onItemAdded(data);
      } else if (window.MinimogEvents) {
        window.MinimogEvents.emit('ON_CART_UPDATE');
      }
    })
    .catch(function(error) {
      console.error('Bundle add error:', error);
      btn.classList.remove('loading');
      btn.disabled = false;
      if (btnText) {
        btnText.style.display = 'block';
        btnText.textContent = 'Fejl - prøv igen';
      }
      if (btnLoading) btnLoading.style.display = 'none';
    });
  }
});
